import { Component, Input, OnInit } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { EmployeeAutomaticMessageHistory } from 'src/app/shared/models/EmployeeAutomaticMessage.item';

@Component({
	selector: 'app-automatic-employee-message-single-history',
	templateUrl: './automatic-employee-message-single-history.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class AutomaticEmployeeMessageSingleHistoryComponent implements OnInit {
	@Input() timecardIdHistory: EmployeeAutomaticMessageHistory[];

	receivedEmployeeList: GenericLabelValue[] = [];

	constructor(public app: AppService) {}

	ngOnInit(): void {
		this.timecardIdHistory.forEach((history) => {
			if (history.timecard?.employee && !this.receivedEmployeeList.some((i) => i.value === history.timecard?.employee.nickName)) {
				this.receivedEmployeeList.push({
					label: history.timecard?.employee.nickName,
					value: history.timecard?.employee.nickName,
					meta: 'user',
				});
			}
		});
	}
}
